// src/services/dimensions.ts
import { api } from "@/lib/apiClient";
import type { Dimension, DimensionListItem, DimensionUpsertIn } from "@/types/dimensions";

export async function listDimensions(params?: {
  q?: string;
  risk_theme?: string;
  is_active?: boolean;
}) {
  return api.get<DimensionListItem[]>("/dimensions", {
    params: {
      q: params?.q || undefined,
      risk_theme: params?.risk_theme || undefined,
      is_active: typeof params?.is_active === "boolean" ? params.is_active : undefined,
    },
  });
}

export async function getDimension(id: string) {
  return api.get<Dimension>(`/dimensions/${id}`);
}

export async function createDimension(payload: DimensionUpsertIn) {
  return api.post<Dimension>("/dimensions", payload);
}

export async function updateDimension(id: string, payload: DimensionUpsertIn) {
  return api.put<Dimension>(`/dimensions/${id}`, payload);
}

export async function setDimensionStatus(id: string, is_active: boolean) {
  return api.patch<Dimension>(`/dimensions/${id}/status`, { is_active });
}

export async function deleteDimension(id: string) {
  return api.delete<void>(`/dimensions/${id}`);
}
